import { render, staticRenderFns } from "./PayrollUploadDragAndDrop.vue?vue&type=template&id=b4cbb154&scoped=true&"
import script from "./PayrollUploadDragAndDrop.vue?vue&type=script&lang=ts&"
export * from "./PayrollUploadDragAndDrop.vue?vue&type=script&lang=ts&"
import style0 from "./PayrollUploadDragAndDrop.vue?vue&type=style&index=0&id=b4cbb154&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cbb154",
  null
  
)

export default component.exports